export const HomeyApiKind = {
  V2: 'v2',
  V3_LOCAL: 'v3-local',
  V3_CLOUD: 'v3-cloud',
} as const;

export type HomeyApiKind = (typeof HomeyApiKind)[keyof typeof HomeyApiKind];
